import React from 'react';

import { Divider } from '@material-ui/core';

import { SectionSkeleton } from '../../MultiStepForm/Skeletons/SectionSkeleton';

interface DrawerFormSkeletonProps {
  count?: number;
  height?: number;
  width?: number;
}

const DrawerFormSkeleton: React.FC<DrawerFormSkeletonProps> = ({
  count = 3,
  height,
  width
}) => {
  return (
    <div>
      {[...Array(count)].map((_, key) => (
        <div key={key}>
          <SectionSkeleton height={height} width={width} />
          <Divider />
        </div>
      ))}
    </div>
  );
};

export default DrawerFormSkeleton;
